module.exports = "/_next/static/images/lknalog_1-e7a59b2505984f1f0b8b8bcff68c68c2.png";